var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Divider',{attrs:{"dashed":""}},[_c('span',{staticClass:"divider-text"},[_vm._v("供应商运维账单")])]),_c(_vm.searchComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }